export const nameSection = "name";
export const titleSection = 'title';
export const descriptionSection = 'description';
export const securitySection = 'disableReCaptcha';

export const touchpointSection = 'touchpointQuestions';
export const demographicsSection = 'demographicQuestions';

export const included = 'isIncluded';
export const required = 'isRequired';
export const order = 'order';
export const elementId = 'elementId';
export const demographicId = 'demographicId';
export const label = 'label';
export const tooltip = 'tooltip';

export const dupeCheckNotificationType = 'dupeCheckNotificationType';

export const editStatus = {
  createNew: 0,
  editExisting: 1
}

export const createNewIntakeId = 'new';
